<template>
  <div class="content" style="width:800px">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="200px" >
      <el-form-item label="资费套餐:" prop="productId">
        <el-select v-model="propsParams.productId" filterable clearable placeholder="请选择资费套餐:" style="width:95%">
          <el-option v-for="item in optPackage" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="ICCID/MSISDN列表:" prop="iccids">
        <el-input
          type="textarea"
          v-model="propsParams.iccids"
          style="width:95%"
          rows="8"
          placeholder="以回车键分割ICCID/MSISDN"
        ></el-input>
      </el-form-item>
      <el-form-item label="ICCID/MSISDN范围:" prop="range">
        <el-row>
          <el-col :span="10">
            <el-input v-model="propsParams.startIccid" placeholder="包含开始值" clearable></el-input>
          </el-col>
          <el-col :span="3" style="text-align: center;">-</el-col>
          <el-col :span="10">
            <el-input v-model="propsParams.endIccid" placeholder="包含终止值" clearable></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit" >提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { batchAutoRenewal } from "@/api/api.js"; //批量充值
import { refuelingPackage } from "@/api/api.js"; //不分页套餐列表
export default {
  name:"topUp",
  data() {
    return {
      propsParams: {},
      submitLoading:false,
      optPackage: [],
      iccids: [],
      ruleValidate: {
        productId: [
          { required: true, message: "请输入资费名", trigger: "blur" }
        ],
      },
    };
  },
  computed: {},
  methods: {
    // 资费套餐下拉
    queryServerList() {
      refuelingPackage().then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data;
          this.dataList.forEach(item => {
            this.optPackage.push({
              value: item.id,
              label: `${item.id}-${item.productName}`
            });
          });
        }
      });
    },
    handleSubmit() {
      let params = {
        ...this.propsParams,
      };
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          if (params.iccids !== undefined) {
            params.iccids = params.iccids.split(/[(\r\n)\r\n]+/);
          }
          batchAutoRenewal(params).then(res => {
            this.$message.success("批量充值成功");
            this.propsParams = {};
          });
        }
      });
    }
  },
  created() {
    this.queryServerList();
  }
};
</script>
<style scoped lang="less">
  @media screen and (max-width: 750px){
    /deep/ .el-form-item__label{
      width: 75px!important;
    }
   /deep/ .el-form-item__content{
     margin-left: 120px!important;
   }
  }
</style>

